import React, { useState } from "react";
import { MPSharedTable, MPSharedDeleteModal, MPSharedHeader } from "../../ManagementPortal/Shared";
import { usePagination, useDelete } from "../../../hooks";
import { useGetAreasQuery, useDeleteAreaMutation } from "../services";
import { AreaForm } from "./form";
import moment from "moment";
import { getLocalizedString } from "../../../shared/translation";

export const AreasContainer = () => {
  const [idToDelete, setIdToDelete] = useState(null);
  const [idToEdit, setIdToEdit] = useState(null);
  const [showDeleteWarning, setShowDeleteWarning] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const { page, setPage, perPage, pagination } = usePagination();

  const queryParams = {
    page: page,
    per_page: perPage,
  };

  const {
    data = {
      total_count: 0,
      data: [],
    },
    error,
    isFetching,
    isSuccess,
  } = useGetAreasQuery({
    ...queryParams,
  });

  const {
    deleteItem: deleteArea,
    deleteErrorMsg,
    setDeleteErrorMsg,
  } = useDelete({
    deleteMutation: useDeleteAreaMutation,
    closeModal: () => setShowDeleteWarning(false),
  });

  const headers = [
    {
      label: "Name",
      key: "name",
      className: "name",
    },
    {
      label: "Code",
      key: "code",
      className: "code",
    },
    {
      label: "Vendor",
      nestedValue: true,
      className: "vendor",
      getNestedValue: ({ vendor }) => vendor?.vendor_name || "-",
    },
    {
      label: "Created At",
      nestedValue: true,
      className: "date",
      getNestedValue: ({ created_at }) =>
        created_at ? moment.unix(created_at).format("DD/MM/YYYY - hh:mm A") : "-",
    },
    {
      label: "Updated At",
      nestedValue: true,
      className: "date",
      getNestedValue: ({ updated_at }) =>
        updated_at ? moment.unix(updated_at).format("DD/MM/YYYY - hh:mm A") : "-",
    },
  ];

  const onEdit = (data) => {
    setShowForm(true);
    setIdToEdit(data.id);
  };

  const onDelete = (data) => {
    setShowDeleteWarning(true);
    setIdToDelete(data.id);
  };

  const onCreate = () => {
    setShowForm(true);
    setIdToEdit(null);
  };

  const getDeleteItemName = (id) => {
    let name = "";
    const index = data?.data.findIndex((item) => item.id === id);

    if (index >= 0) {
      name = data.data[index].name;
    }
    return name;
  };

  return (
    <>
      <article className="main-container">
        <MPSharedHeader
          groupName="area"
          resourceName="Areas"
          createNewHandler={onCreate}
          heading="Areas"
          skipCanCreate
          skipCurrentUserCheck
        />

        <MPSharedTable
          resourceName="Areas"
          data={data?.data || []}
          error={error}
          isLoading={isFetching}
          isSuccess={isSuccess}
          headers={headers}
          onEdit={onEdit}
          onDelete={onDelete}
          pagination={{ ...pagination, count: data.total_count }}
          skipClientId
          skipCanEdit
          skipCanDelete
          skipCurrentUserCheck
          className="areas"
        />

        {showForm && <AreaForm id={idToEdit} showForm={showForm} setShowForm={setShowForm} />}

        {showDeleteWarning && (
          <MPSharedDeleteModal
            show={showDeleteWarning}
            entityName={getLocalizedString("area_delete", "area")}
            itemName={getDeleteItemName(idToDelete)}
            error={deleteErrorMsg}
            onHide={() => {
              setDeleteErrorMsg("");
              setShowDeleteWarning(false);
            }}
            onDelete={() => deleteArea({ id: idToDelete })}
          />
        )}
      </article>
    </>
  );
};
